/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateValidateResponse {
    getFixupPrototypeFunction() { return TemplateValidateResponse.fixupPrototype; }

    static newInstance(model: Partial<TemplateValidateResponse>): TemplateValidateResponse {
        let obj = Object.assign(new TemplateValidateResponse(), model);
        TemplateValidateResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateValidateResponse>): TemplateValidateResponse {
        if (!model) return null;
        return TemplateValidateResponse.newInstance(<TemplateValidateResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateValidateResponse) {
        if (!obj) return;

        models.TemplateValidateResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateValidateResponse): boolean {
        Object.setPrototypeOf(obj, TemplateValidateResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Job identifier of the executed template
     */
    validation_status: string;

}
